import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const HittaElavtal = lazy(() => import("@/pages/verktyg/HittaElavtal"));

export const Route = createFileRoute("/verktyg/hitta-elavtal")({
  head: () => seoHead("/verktyg/hitta-elavtal", { description: "Vårt verktyg analyserar din bostadsstorlek, förbrukning och elområde och visar de mest relevanta avtalen för just dig." }),
  component: () => <HittaElavtal />,
});
